// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"31":"2423a3bb","33":"04ce81ac","103":"9ad488a3","272":"5ef74d4d","287":"8c05c6d7","325":"2d5d39eb","377":"7b0ed2e4","479":"22347233","795":"836c2cab","957":"491ef1d2"}[chunkId] + ".js";
};